module.exports = __webpack_public_path__ + "static/media/ftMyerBasketball.d561a64f.png";